// @flow

import isPlainObject from "lodash/isPlainObject";

const dictionary = {
  buba: {
    consultant: {
      creator: "Berater",
      uploadedFor: "Unterlagen für die Banken",
      downloadFrom: "Unterlagen von der Bank",
      companyLabel: "Unternehmensname",
      requestFrom: "Weitere Unterlagen vom Kunden anfordern",
      tableBankHeader: "Gewählte Hausbank",
      entrepreneurType: "Kunde ist ein...",
      financingSectionTitle: "Finanzierungsdetails",
      investmentSectionTitle: "Kundenvorhaben"
    },
    customer: {
      creator: "Kunde",
      uploadedFor: "Unterlagen für die Banken",
      downloadFrom: "Unterlagen von der Bank",
      companyLabel: "Unternehmensname",
      requestFrom: "Weitere Unterlagen vom Kunden anfordern",
      tableBankHeader: "Gewählte Hausbank",
      entrepreneurType: "Kunde ist ein...",
      financingSectionTitle: "Finanzierungsdetails",
      investmentSectionTitle: "Kundenvorhaben"
    },
    bankAdvisor: {
      creator: "Einsteller",
      uploadedFor: "Unterlagen für den Einsteller",
      downloadFrom: "Unterlagen vom Einsteller",
      companyLabel: "Ihr Unternehmen",
      requestFrom: "Weitere Unterlagen vom Einsteller anfordern",
      tableBankHeader: "Einsteller",
      entrepreneurType: "Kunde ist ein...",
      financingSectionTitle: "Finanzierungsdetails",
      investmentSectionTitle: "Kundenvorhaben"
    },
    leasingAdvisor: {
      creator: "Einsteller",
      uploadedFor: "Unterlagen für die Leasinggesellschaft",
      downloadFrom: "Unterlagen von der Leasinggesellschaft",
      companyLabel: "Ihr Unternehmen",
      requestFrom: "Weitere Unterlagen vom Einsteller anfordern",
      tableBankHeader: "Einsteller",
      entrepreneurType: "Kunde ist ein...",
      financingSectionTitle: "Finanzierungsdetails",
      investmentSectionTitle: "Kundenvorhaben"
    }
  },
  bank: {
    customer: {
      creator: "Kunde",
      companyLabel: "Unternehmensname",
      entrepreneurType: "Kunde ist ein...",
      financingSectionTitle: "Finanzierungsdetails",
      investmentSectionTitle: "Kundenvorhaben"
    },
    bankAdvisor: {
      creator: "Einsteller",
      companyLabel: "Ihr Unternehmen",
      entrepreneurType: "Kunde ist ein...",
      financingSectionTitle: "Finanzierungsdetails",
      investmentSectionTitle: "Kundenvorhaben"
    }
  },
  customer: {
    customer: {
      creator: "Kunde",
      companyLabel: "Ihr Unternehmen",
      entrepreneurType: "Ich bin ein...",
      financingSectionTitle: "Finanzierungsvorhaben",
      investmentSectionTitle: "Mein Vorhaben"
    },
    bankAdvisor: {
      creator: "Kunde",
      companyLabel: "Ihr Unternehmen",
      entrepreneurType: "Ich bin ein...",
      financingSectionTitle: "Finanzierungsvorhaben",
      investmentSectionTitle: "Mein Vorhaben"
    }
  }
};

// eslint-disable-next-line import/prefer-default-export
export const chooseType = (
  site: "buba" | "bank" | "customer",
  type: "consultant" | "customer" | "bankAdvisor" | "leasingAdvisor"
) => {
  const dictionaryForSite = dictionary[site];

  return isPlainObject(dictionaryForSite) ? dictionaryForSite[type] : {};
};
